import React from 'react';

class DelRoomList extends React.Component {
  render() {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.4037 8.36852C14.5166 8.14267 14.7475 8 15 8H17.6667C17.9192 8 18.15 8.14267 18.263 8.36852L18.7454 9.33333H21.6667V10.6667H11V9.33333H13.9213L14.4037 8.36852ZM15.6667 20.3333V15.3333H17V20.3333H15.6667Z"
          fill="#8A8B8D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.1669 12.2255C11.2934 12.0821 11.4754 12 11.6667 12H21C21.1912 12 21.3732 12.0821 21.4998 12.2255C21.6263 12.3688 21.6852 12.5596 21.6615 12.7494L20.6202 21.0801C20.4117 22.7482 18.9937 24 17.3126 24H15.3541C13.673 24 12.255 22.7482 12.0465 21.0801L11.0052 12.7494C10.9814 12.5596 11.0403 12.3688 11.1669 12.2255ZM12.4219 13.3333L13.3695 20.9147C13.4946 21.9156 14.3454 22.6667 15.3541 22.6667H17.3126C18.3212 22.6667 19.172 21.9156 19.2971 20.9147L20.2448 13.3333H12.4219Z"
          fill="#8A8B8D"
        />
      </svg>
    );
  }
}

export default DelRoomList;
